document.addEventListener("DOMContentLoaded", function () {
  var openBtn = document.getElementById("open-condition-builder");
  if (!openBtn) return;

  var FIELDS = window.__conditionFields || [];
  var USERS = window.__usersOptions || [];
  var modal = document.getElementById("condition-builder-modal");
  var dimmer = document.getElementById("condition-builder-dimmer");
  var root = document.getElementById("condition-builder-root");
  var textarea = document.getElementById("condition-textarea");

  // --- Modal show/hide ---

  function showModal() {
    dimmer.style.display = "flex";
    requestAnimationFrame(function () {
      dimmer.style.opacity = "1";
    });
  }

  function hideModal() {
    dimmer.style.opacity = "0";
    setTimeout(function () { dimmer.style.display = "none"; }, 200);
  }

  // --- UI helpers ---

  function createFieldSelect(selected) {
    var sel = document.createElement("select");
    sel.className = "ui dropdown cb-field-select";
    sel.style.width = "160px";
    sel.innerHTML = '<option value="">-- 条件を選択 --</option>' +
      FIELDS.map(function (f) {
        var key = f.model + "." + f.field;
        var isSel = key === selected ? " selected" : "";
        return '<option value="' + key + '"' + isSel + '>' + f.label + '</option>';
      }).join("");
    return sel;
  }

  function findFieldDef(key) {
    return FIELDS.find(function (f) { return f.model + "." + f.field === key; });
  }

  function createOperatorSelect(operators, selected) {
    var sel = document.createElement("select");
    sel.className = "ui dropdown cb-operator-select";
    sel.style.width = "80px";
    sel.innerHTML = operators.map(function (op) {
      var isSel = op === selected ? " selected" : "";
      return '<option value="' + op + '"' + isSel + '>' + op + '</option>';
    }).join("");
    return sel;
  }

  function createValueInput(fieldDef, value) {
    if (fieldDef.value_type === "user_ids") {
      return createUserPicker(value || []);
    }
    if (fieldDef.value_type === "select") {
      return createSelectInput(fieldDef.options || [], value);
    }
    var input = document.createElement("input");
    input.type = "number";
    input.className = "cb-value-input";
    input.style.width = "150px";
    if (value !== undefined && value !== null) input.value = value;
    return input;
  }

  function createSelectInput(options, selectedValue) {
    var sel = document.createElement("select");
    sel.className = "ui dropdown cb-value-select";
    sel.style.width = "150px";
    sel.innerHTML = options.map(function (opt) {
      var label = opt[0], val = opt[1];
      var isSel = val === selectedValue ? " selected" : "";
      return '<option value="' + val + '"' + isSel + '>' + label + '</option>';
    }).join("");
    return sel;
  }

  function createUserPicker(selectedIds) {
    var wrapper = document.createElement("div");
    wrapper.className = "cb-user-picker";
    wrapper.style.cssText = "position:relative; width:280px;";

    // 選択済みタグ表示エリア
    var tagsArea = document.createElement("div");
    tagsArea.className = "cb-user-tags";
    tagsArea.style.cssText = "display:flex; flex-wrap:wrap; gap:4px; margin-bottom:4px; min-height:24px;";
    wrapper.appendChild(tagsArea);

    // 検索入力
    var input = document.createElement("input");
    input.type = "text";
    input.placeholder = "ユーザー名を入力して検索...";
    input.style.cssText = "width:250px; padding:6px 8px; border:1px solid #ddd; border-radius:4px; font-size:0.9em;";
    wrapper.appendChild(input);

    // 候補ドロップダウン
    var dropdown = document.createElement("div");
    dropdown.className = "cb-user-dropdown";
    dropdown.style.cssText = "position:absolute; left:0; right:0; max-height:200px; overflow-y:auto; background:#fff; border:1px solid #ddd; border-top:none; border-radius:0 0 4px 4px; z-index:10; display:none;";
    wrapper.appendChild(dropdown);

    // 選択済みID管理
    var selected = new Set(selectedIds);

    function findUser(id) {
      return USERS.find(function (u) { return u[1] === id; });
    }

    function userLabel(id) {
      var u = findUser(id);
      if (!u) return "ID:" + id;
      return u[2] ? u[0] + "（" + u[2] + "）" : u[0];
    }

    function renderTags() {
      tagsArea.innerHTML = "";
      selected.forEach(function (id) {
        var tag = document.createElement("span");
        tag.style.cssText = "display:inline-flex; align-items:center; gap:4px; padding:2px 8px; background:#e8e8e8; border-radius:3px; font-size:0.85em;";
        var u = findUser(id);
        tag.textContent = u ? u[0] + " (ID:" + u[1] + ")" : "ID:" + id;
        var x = document.createElement("span");
        x.textContent = "×";
        x.style.cssText = "cursor:pointer; font-weight:bold; color:#999; margin-left:2px;";
        x.addEventListener("click", function () {
          selected.delete(id);
          renderTags();
        });
        tag.appendChild(x);
        tagsArea.appendChild(tag);
      });
    }

    function renderDropdown(query) {
      dropdown.innerHTML = "";
      var q = query.toLowerCase();
      var matches = USERS.filter(function (u) {
        return !selected.has(u[1]) && u[0].toLowerCase().indexOf(q) !== -1;
      });

      if (matches.length === 0) {
        dropdown.style.display = "none";
        return;
      }

      matches.slice(0, 20).forEach(function (u) {
        var item = document.createElement("div");
        item.textContent = u[0] + " (ID:" + u[1] + "/" + (u[2] || "") + ")";
        item.style.cssText = "padding:6px 10px; cursor:pointer;";
        item.addEventListener("mouseenter", function () { item.style.background = "#f0f0f0"; });
        item.addEventListener("mouseleave", function () { item.style.background = ""; });
        item.addEventListener("mousedown", function (e) {
          e.preventDefault();
          selected.add(u[1]);
          input.value = "";
          dropdown.style.display = "none";
          renderTags();
        });
        dropdown.appendChild(item);
      });
      dropdown.style.display = "";
    }

    input.addEventListener("input", function () {
      if (this.value.length > 0) {
        renderDropdown(this.value);
      } else {
        dropdown.style.display = "none";
      }
    });

    input.addEventListener("focus", function () {
      if (this.value.length > 0) renderDropdown(this.value);
    });

    input.addEventListener("blur", function () {
      setTimeout(function () { dropdown.style.display = "none"; }, 150);
    });

    // 初期タグ描画
    renderTags();

    // readRowData用にselectedを取得できるようにする
    wrapper.getSelectedIds = function () {
      return Array.from(selected);
    };

    return wrapper;
  }

  // --- Condition row ---

  function createConditionRow(data) {
    var row = document.createElement("div");
    row.className = "cb-condition-row";
    row.style.cssText = "display: flex; align-items: center; gap: 8px; margin-bottom: 8px; padding: 8px 12px; background: #f9f9f9; border-radius: 4px; flex-wrap: wrap;";

    var fieldKey = data ? data.model + "." + data.field : "";
    var fieldSel = createFieldSelect(fieldKey);
    row.appendChild(fieldSel);

    var controlsDiv = document.createElement("span");
    controlsDiv.className = "cb-controls";
    controlsDiv.style.cssText = "display: flex; align-items: center; gap: 8px; flex-wrap: wrap;";
    row.appendChild(controlsDiv);

    if (fieldKey) {
      populateControls(row, fieldKey, data);
    }

    fieldSel.addEventListener("change", function () {
      populateControls(row, this.value, null);
    });

    var removeBtn = document.createElement("button");
    removeBtn.type = "button";
    removeBtn.className = "ui red basic mini icon button";
    removeBtn.innerHTML = '<i class="trash icon"></i>';
    removeBtn.style.cssText = "flex-shrink:0; margin-left:auto;";
    removeBtn.addEventListener("click", function () {
      row.remove();
    });
    row.appendChild(removeBtn);

    return row;
  }

  function populateControls(row, fieldKey, data) {
    var controls = row.querySelector(".cb-controls");
    controls.innerHTML = "";
    var fieldDef = findFieldDef(fieldKey);
    if (!fieldDef) return;

    var opSel = createOperatorSelect(fieldDef.operators, data ? data.operator : fieldDef.operators[0]);
    controls.appendChild(opSel);

    var valInput = createValueInput(fieldDef, data ? data.value : null);
    controls.appendChild(valInput);
  }

  // --- Parse / Build JSON ---

  function parseCondition(json) {
    if (!json) return { logic: "and", items: [] };

    if (json.field) {
      return { logic: "and", items: [json] };
    }

    var logic = json.and ? "and" : "or";
    var nodes = json[logic] || [];

    var items = [];
    var hasNesting = false;
    nodes.forEach(function (node) {
      if (node.field) {
        items.push(node);
      } else if (node.and || node.or) {
        hasNesting = true;
      }
    });

    return { logic: logic, items: items, hasNesting: hasNesting };
  }

  function readRowData(row) {
    var fieldSel = row.querySelector(".cb-field-select");
    if (!fieldSel || !fieldSel.value) return null;

    var fieldDef = findFieldDef(fieldSel.value);
    if (!fieldDef) return null;

    var opSel = row.querySelector(".cb-operator-select");
    var operator = opSel ? opSel.value : fieldDef.operators[0];

    var value;
    if (fieldDef.value_type === "user_ids") {
      var picker = row.querySelector(".cb-user-picker");
      value = picker && picker.getSelectedIds ? picker.getSelectedIds() : [];
    } else if (fieldDef.value_type === "select") {
      var selectInput = row.querySelector(".cb-value-select");
      if (!selectInput || !selectInput.value) return null;
      value = selectInput.value;
    } else {
      var numInput = row.querySelector(".cb-value-input");
      if (!numInput || numInput.value === "") return null;
      value = parseFloat(numInput.value);
      if (isNaN(value)) return null;
    }

    return {
      model: fieldDef.model,
      field: fieldDef.field,
      operator: operator,
      value: value
    };
  }

  function buildJSON() {
    var rows = root.querySelectorAll(".cb-condition-row");
    var items = [];
    rows.forEach(function (row) {
      var data = readRowData(row);
      if (data) items.push(data);
    });

    if (items.length === 0) return "{}";
    if (items.length === 1) return JSON.stringify(items[0], null, 2);

    var logic = document.getElementById("cb-root-logic").value;
    var obj = {};
    obj[logic] = items;
    return JSON.stringify(obj, null, 2);
  }

  // --- Events ---

  openBtn.addEventListener("click", function () {
    root.innerHTML = "";

    var existing = null;
    try {
      var text = textarea.value.trim();
      if (text) existing = JSON.parse(text);
    } catch (e) {
      // パース失敗時は空で開く
    }

    var parsed = parseCondition(existing);
    document.getElementById("cb-root-logic").value = parsed.logic;

    if (parsed.hasNesting) {
      alert("この条件は入れ子構造を含んでいるため、ビルダーでは編集できません。テキストエリアで直接編集してください。");
      return;
    }

    if (parsed.items.length > 0) {
      parsed.items.forEach(function (item) {
        root.appendChild(createConditionRow(item));
      });
    } else {
      root.appendChild(createConditionRow(null));
    }

    showModal();
  });

  document.getElementById("cb-add-condition").addEventListener("click", function () {
    root.appendChild(createConditionRow(null));
  });

  document.getElementById("cb-apply").addEventListener("click", function () {
    textarea.value = buildJSON();
    hideModal();
  });

  document.getElementById("cb-cancel").addEventListener("click", function () {
    hideModal();
  });

  dimmer.addEventListener("click", function (e) {
    if (e.target === dimmer) hideModal();
  });
});
